import React from "react";
import { Link } from "react-router-dom";
const Infrastructure = () => {
  return (
      <div>
          {/* Spinner Start */}
         
          {/* Spinner End */}
      
   
      <div class="container">
          <section class="pace-section">
        <h2>Pioneering Excellence with <span class="green-text">PACE TECHNOLOGY</span></h2>
        <p>Embark on a transformative journey through the heart of Tileque Surfaces LLP, where innovation and precision converge to create a symphony of excellence in SPC flooring production.</p>
    </section>

    <section class="manufacturing-section">
        <div class="content">
            <h3>SPC Extrusion Line: <span class="green-text">Mastering Excellence</span></h3>
            <p>Step into our meticulously designed SPC Extrusion Line, where European-standard machines under PACE TECHNOLOGY ensure a seamless production process.</p>
        </div>
        <img class="img-fluid" src="/assets/img/spcel.jpg" alt="SPC Extrusion Line"/>
    </section>

    <section class="manufacturing-section">
        <div class="content">
            <h3>UV Coating Line: <span class="green-text">Shielding Craftsmanship</span></h3>
            <p>Experience craftsmanship shielded in our UV Coating Line, housed in a dedicated chamber.</p>
        </div>
        <img src="/assets/img/uv-coating.jpg" alt="UV Coating Line"/>
    </section>

    <section class="manufacturing-section">
        <div class="content">
            <h3>Homag Profile Line: <span class="green-text">Precision in Every Cut</span></h3>
            <p>Encounter German precision with our Homag Profile Line, sculpting click profiles with unparalleled accuracy.</p>
        </div>
        <img src="/assets/img/homag-profile.jpg" alt="Homag Profile Line"/>
    </section>

    <section class="manufacturing-section">
        <div class="content">
            <h3>Unilin Partnership: <span class="green-text">Elevated Click Design</span></h3>
            <p>Immerse yourself in the artistry of click design through our partnership with Unilin Technologies.</p>
        </div>
    </section>

    <section class="manufacturing-section">
        <div class="content">
            <h3>Underpad Lamination Machine: <span class="green-text">Harmonizing Acoustics</span></h3>
            <p>Feel the harmony of acoustics with our European-standard Underpad Lamination Machine.</p>
        </div>
        <img src="/assets/img/underpad-lamination.jpg" alt="Underpad Lamination Machine"/>
    </section>

    <section class="manufacturing-section">
        <div class="content">
            <h3>Bevel Paint Machine: <span class="green-text">Natural Finesse</span></h3>
            <p>Explore the final touch of natural finesse with our Bevel Paint Machine.</p>
        </div>
        <img src="/assets/img/bevel-paint.jpg" alt="Bevel Paint Machine"/>
    </section>

    <section class="technology-partner">
        <h3>Our Technology Partner</h3>
        <img src="/assets/img/partners.jpg" alt="Technology Partners"/>
        <p>Plankton Floors is the license holder of patents for UNILIN’s UNICLIC technology.</p>
    </section>
    </div>
      
      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
          <i className="bi bi-arrow-up"></i>
        </a>
    
    
          {/* Optional: Add any other content or components here */}
      
          <style>
            {`
              /* Add your custom CSS here */
              .service-item-top {
                transition: transform 0.3s ease-in-out;
              }
      .container{margin-top:50px}
              .service-item-top:hover {
                transform: scale(1.05);
              }
            .pace-section {
            margin-top: 57px;
    text-align: center;
    padding: 40px;
    background-color: #fff;

    margin: auto;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.green-text {
    color: #15803d;
    font-weight: bold;
}

/* Manufacturing Sections */
.manufacturing-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
  
    margin: 40px auto;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.manufacturing-section img {
    width: 50%;
    border-radius: 8px;
}

.content {
    width: 45%;
    padding-right: 20px;
}

/* Technology Partner */
.technology-partner {
    text-align: center;
    padding: 30px;
    background: #fff;
    max-width: 900px;
    margin: 40px auto;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.technology-partner img {
    width: 80%;
    margin-top: 10px;
}

/* Responsive */
@media (max-width: 768px) {
    .manufacturing-section {
        flex-direction: column;
        text-align: center;
    }

    .manufacturing-section img {
        width: 100%;
        margin-top: 15px;
    }

    .content {
        width: 100%;
        padding: 0;
    }
}
              /* Add any additional styling you want */
            `}
          </style>
        </div>
  );
};

export default Infrastructure;
